import { render, staticRenderFns } from "./LandingLoader.vue?vue&type=template&id=a3c05df2&scoped=true"
import script from "./LandingLoader.vue?vue&type=script&lang=js"
export * from "./LandingLoader.vue?vue&type=script&lang=js"
import style0 from "./LandingLoader.vue?vue&type=style&index=0&id=a3c05df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c05df2",
  null
  
)

export default component.exports